import { Injectable, DOCUMENT, inject } from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class LandingFixService {
  private document = inject<Document>(DOCUMENT);


  // Add or Remove class
  public addNavFix() {
     this.document.getElementById('mySidenav').classList.add('open-side');
  }

  public removeNavFix() {
     this.document.getElementById('mySidenav').classList.remove('open-side');
  }

}
